exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul {\n  list-style-type: none;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  margin-top: 0px;\n  margin-bottom: 0px;\n  margin-left: 2px;\n  margin-right: 2px;\n  padding: 0;\n  border-style: solid;\n  border-width: 1px;\n  border-color: gray;\n  height: 200px; }\n\nul li {\n  padding-left: 4px;\n  padding-right: 4px;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-bottom-color: gray;\n  cursor: grab;\n  cursor: -webkit-grab; }\n\nul li:active {\n  cursor: grabbing;\n  cursor: -webkit-grabbing; }\n\nul li:nth-child(even) {\n  background-color: #fff; }\n\nul li:nth-child(odd) {\n  background-color: #e6e5e5; }\n\nul::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px #e6e5e5;\n  background-color: #F5F5F5; }\n\nul::-webkit-scrollbar {\n  width: 8px;\n  background-color: #F5F5F5; }\n\nul::-webkit-scrollbar-thumb {\n  background-color: #607d8b;\n  border: 2px solid #e6e5e5; }\n\n.mySubHeading {\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Source/Ecim/Ecim.Web/src/app/components/assign-members/assign-members.component.scss
// module id = ../../../../../src/app/components/assign-members/assign-members.component.scss
// module chunks = main